import React from 'react'
import { Col, Row } from 'react-bootstrap'
import useActiveLink from '../components/useActiveLink'

const Footer = () => {
    const { handleLinkClick } = useActiveLink('.navbar-nav li.active');
    return (
        <React.Fragment>
            <footer className="section blog-bg-footer pb-5">
                <div className="container">
                    <Row>
                        <Col lg={5}>
                            <div>
                                <h6 className="footer-heading text-uppercase fw-bold f-13">Social Links</h6>
                                <ul className="list-unstyled footer-link mt-3 mb-0">
                                    <li><a href="#facebook">Facebook</a></li>
                                    <li><a href="#linkedin">Linkedin</a></li>
                                    <li><a href="#instagram">Instagram</a></li>
                                    <li><a href="#youtube">Youtube</a></li>
                                </ul>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div>
                                <h6 className="footer-heading text-uppercase fw-bold f-13">Help</h6>
                                <ul className="list-unstyled footer-link mt-3 mb-0">
                                    <li><a href="#contact">Contact</a></li>
                                    <li><a href="#faq">FAQ</a></li>
                                    <li><a href="#terms-of-service">Terms of Service</a></li>
                                    <li><a href="#privacy-policy">Privacy Policy</a></li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div>
                                <h6 className="footer-heading text-uppercase fw-bold f-13">Information</h6>
                                <ul className="list-unstyled footer-link mt-3 mb-0">
                                    <li><a href='#services' onClick={() => handleLinkClick('/services')}>Services</a></li>
                                    <li><a href='#work' onClick={() => handleLinkClick('/work')}>Portfolio</a></li>
                                    <li><a href='#pricing' onClick={() => handleLinkClick('/pricing')}>Pricing</a></li>
                                    <li><a href='#about' onClick={() => handleLinkClick('/about')}>About Us</a></li>
                                </ul>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col lg={12}>
                            <div className="agency-footer-alt-content p-4">
                                <p className="copy-right text-center mb-0">
                                    © {new Date().getFullYear()} A.Rehman Web Solutions. All Rights Reserved.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </footer>
        </React.Fragment>
    )
}

export default Footer
